// @ts-nocheck
import React from 'react';
import { sx } from '../sx';
import { NOTE, SEGMENT, SEGMENTS, SELECT, SPLIT, pill } from '../controls';

export default function PlanToolbar({ vm }: { vm: any }) {
  if (!vm.barsOpen) return null;
  return (
    <div style={sx(`flex:none;display:flex;align-items:center;flex-wrap:wrap;gap:10px 12px;padding:11px 20px;border-bottom:1px solid #DCE4F2`)}>
      <div style={sx(`flex:none;display:flex;align-items:center;gap:6px`)}>
        <select value={vm.customFrom} onChange={vm.onCustomFrom} style={sx(SELECT)}>
          {(vm.monthOpts || []).map((o, i) => (
            <option key={i} value={o.value}>{o.label}</option>
          ))}
        </select>
        <span style={sx(`flex:none;font-size:12px;color:var(--ink-4)`)}>to</span>
        <select value={vm.customTo} onChange={vm.onCustomTo} style={sx(SELECT)}>
          {(vm.monthOpts || []).map((o, i) => (
            <option key={i} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
      <div style={sx(SEGMENTS)}>
        {(vm.grans || []).map((g, i) => (
          <button key={i} type="button" aria-pressed={!!g.selected} onClick={g.onClick} style={sx(`${SEGMENT};box-shadow:${g.selected ? 'none' : g.divider};background:${g.bg};color:${g.fg};font-weight:${g.fw}`)}>{g.label}</button>
        ))}
      </div>
      <div style={sx(SPLIT)}></div>
      <select value={vm.cmpVersion} onChange={vm.onCmpVersion} style={sx(`${SELECT};max-width:190px`)}>
        {(vm.cmpOpts || []).map((o, i) => (
          <option key={i} value={o.value}>{o.label}</option>
        ))}
      </select>
      {vm.cmpActuals ? <div style={sx(`${NOTE};background:#EDF1F8`)}>{vm.cmpActualsNote}</div> : null}
      {vm.showNewScenario ? (
        <button className="gmHover" onClick={vm.startScenario} style={sx(`${pill()};color:#0060a8`)} data-hover="border-color:#00B3FF">＋ New scenario</button>
      ) : null}
      {vm.cmpOn ? (
        <div style={sx(`flex:none;display:flex;gap:6px`)}>
          {(vm.cmpModes || []).map((m, i) => (
            <button key={i} type="button" onClick={m.onClick} style={sx(`${pill(m.border)};background:${m.bg};color:${m.fg}`)}>{m.label}</button>
          ))}
        </div>
      ) : null}
      {vm.isAll ? <div style={sx(`${NOTE};background:var(--bg-2)`)}>{vm.rollupNote}</div> : null}
      {vm.hasPasteNote ? (
        <div style={sx(`${NOTE};padding:0 6px 0 12px;background:${vm.pasteBg};color:${vm.pasteFg}`)}>
          {vm.pasteNote}
          <button className="gmHover" onClick={vm.clearPaste} style={sx(`flex:none;width:18px;height:18px;display:flex;align-items:center;justify-content:center;border:none;border-radius:999px;background:none;color:inherit;font-family:inherit;font-size:12px;line-height:1;cursor:pointer`)} data-hover="background:rgba(8,35,76,0.08)">×</button>
        </div>
      ) : null}
    </div>
  );
}
